import React from 'react';
import {
  CurrentOfferCost,
  NewOfferCost,
  ResiliationFormulaState,
  Savings,
  TerminationFees,
} from './types';

interface FreeResiliationFormulaContextProps {
  state: ResiliationFormulaState;
  updateState: React.Dispatch<React.SetStateAction<ResiliationFormulaState>>;
  terminationFees?: TerminationFees;
  currentOfferCost?: CurrentOfferCost;
  newOfferCost?: NewOfferCost;
  savings?: Savings;
  completedSteps: {
    'commitment': boolean,
    'price': boolean,
    'contract': boolean,
  };
  expanded: string | null;
  setExpanded: (newValue: string | null) => void;
  clear: () => void;
}

const FreeResiliationFormulaContext = React.createContext<FreeResiliationFormulaContextProps | null>(null);

export default FreeResiliationFormulaContext;
